import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../../constants/routeConstants.json";
import { admiRoleListApi, addAdminApi, commonRoleList } from "../../../api/Api";
import { useCookies } from "react-cookie";
import {
  validateName,
  validateEmail,
  spaceCheck,
} from "../../../utils/service";
import ContentData from "../../../constants/contentFile.json";
import { handleApiError } from "../../../constants/Constants";

export const AddAdminContext = createContext({});
export const AddAdminContextProvider = ({ children }) => {
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [successPopupMessage, setSuccessPopupMessage] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [validatedName, setValidatedName] = useState("");
  const [statusValue, setStatusValue] = useState(0);
  const [roleList, setRoleList] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [emailValidationMsg, setEmailValidationMsg] = useState("");
  const [roleCategotyValidate, setRoleCategotyValidate] = useState([]);
  const [successAlertShow, setSuccessAlertShow] = useState(false);
  const [successAlertMessage, setSuccessAlertMessage] = useState("");
  const [errorAlertShow, setErrorAlertShow] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [permissionAccess, setPermissionAccess] = useState(
    JSON.parse(localStorage.getItem("permissions"))?.filter((item) => {
      return item.feature === "66f506fa5a192b6c70a82cd8";
    })[0]
  );

  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);

  const adminToLogin = () => {
    removeCookie("x-access-token");
    navigate(RouteConstants.LOGIN);
  };
  const adminUserList = () => {
    navigate(RouteConstants.ADMIN_LIST);
  };
  const adminUserAdd = () => {
    navigate(RouteConstants.ADD_ADMIN);
  };
  // close error modal
  const onHandleClose = () => {
    setErrorPopup(false);
  };

  const roleValidation = (value) => {
    if (value === "") {
      setRoleCategotyValidate("Select role");
      return false;
    } else {
      setRoleCategotyValidate("");
      return true;
    }
  };

  const handleRoleChange = (e) => {
    setRole(e.target.value);
    roleValidation(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);

    if (emailValidationMsg && emailValidation(e.target.value)) {
      setEmailValidationMsg("");
    }
  };

  const emailValidation = (value) => {
    if (!validateEmail(value)) {
      // setEmailValidationMsg(ContentData.authPage.emailRequired);
      setEmailValidationMsg(ContentData.authPage.invalidEmail);

      return false;
    } else if (!validateEmail(value)) {
      setEmailValidationMsg(ContentData.authPage.invalidEmail);
      return false;
    } else {
      setEmailValidationMsg("");
      return true;
    }
  };

  const handleEmailBlur = () => {
    emailValidation(email);
  };

  const nameValidation = (value) => {
    if (value === "") {
      setValidatedName(ContentData.adminPage.enterName);
      return false;
    } else if (!validateName(value)) {
      setValidatedName(ContentData.adminPage.validName);
      return false;
    } else {
      setValidatedName("");
      return true;
    }
  };

  const handleName = (e) => {
    const value = e.target.value;
    const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);
    setName(capitalizedValue);

    // Clear error dynamically if the name is valid
    if (validatedName && nameValidation(value)) {
      setValidatedName("");
    }
  };

  const roleListShown = async () => {
    try {
      const data = await commonRoleList();
      if (data?.data?.statusCode === 200) {
        setRoleList(data?.data?.data?.roleList);
      }
    } catch (error) {
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
    }
    setSpinnerStatus(false);
  };

  const addAdminformValidation = async (e) => {
    e.preventDefault();
    const adminDetails = {
      name: name,
      email: email,
      role: role,
    };
    const nameValidate = nameValidation(name);
    const emailValidate = emailValidation(email);
    const roleValidate = roleValidation(role);
    if (nameValidate && emailValidate && roleValidate) {
      try {
        setSpinnerStatus(true);
        const getData = await addAdminApi(adminDetails);
        if (getData?.data?.statusCode === 200) {
          setErrorAlertShow(false);
          setSuccessAlertShow(true);
          setSpinnerStatus(false);
          setSuccessAlertMessage(getData?.data?.message);
        }
      } catch (error) {
        handleApiError(
          error,
          setStatusValue,
          setErrorPopupMessage,
          setErrorPopup,
          setButtonText
        );
      }
      setSpinnerStatus(false);
    }
  };

  const providerValue = {
    spinnerStatus,
    roleList,
    handleRoleChange,
    emailValidationMsg,
    roleCategotyValidate,
    role,
    roleListShown,
    addAdminformValidation,
    handleName,
    name,
    handleEmailChange,
    validatedName,
    email,
    adminUserList,
    adminUserAdd,
    successAlertMessage,

    successAlertShow,
    errorAlertMessage,

    errorAlertShow,
    setErrorAlertShow,
    spinnerStatus,
    statusValue,
    buttonText,
    adminToLogin,
    handleEmailBlur,
    nameValidation,
    permissionAccess,

    errorPopup,
    setErrorPopup,
    errorPopupMessage,
    setErrorPopupMessage,
  };
  return (
    <AddAdminContext.Provider value={providerValue}>
      {children}
    </AddAdminContext.Provider>
  );
};
